import PAImage from "component/design-system/images/PAImage";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";

interface IProps {
  width?: number;
  height?: number;
}

function FlexitiLogo(props: IProps) {
  const { width, height } = props;
  const altText = "Pay With Flexiti";
  return (
    <PAImage
      unoptimized
      width={width || 50}
      height={height || 16}
      src={getRelativeImagePath("/images/public/third-party/flexiti-logo.png")}
      alt={altText}
      title={altText}
    />
  );
}

export default FlexitiLogo;
